/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { SelectList } from '@abyss/ui/form/SelectList';
import { useForm } from '@abyss/ui/form/hooks/useForm';
import { useProvidersSearch } from 'src/hooks/useProvidersSearch';
import { styled } from '@abyss/ui/tools/styled';
import { AlertContext } from 'src/tools/AlertContext';

const CustomLabel = styled.label({
  fontSize: ({ theme }) => theme.fontSizes.size400,
  color: ({ theme }) => theme.colors.UHC_GRAY_DARK,
  fontWeight: 600,
});

export const CareProviders = ({
  uuid,
  selectedProvider,
  setSelectedProvider,
  allowProviderSearch,
}) => {
  const form = useForm();
  const errorContext = useContext(AlertContext);
  const {
    organizationId,
    corporateProviderMpin,
    taxIdNumber,
  } = selectedProvider;
  const [providerResult, getProviders] = useProvidersSearch({
    onCompleted: response => {
      if (response.length === 1) {
        const firstProvider = response[0];
        form.set('utility.servicingProvider', firstProvider);

        setSelectedProvider({
          organizationId,
          corporateProviderMpin,
          taxIdNumber,
          servicingProvider: firstProvider.mpin,
        });
      }
    },
    onError: error => {
      errorContext.addAlert(error);
    },
  });
  const providers = providerResult.data || [];

  useEffect(() => {
    if (allowProviderSearch) {
      if (taxIdNumber) {
        getProviders({
          variables: JSON.stringify({
            id: selectedProvider.uhcOrgId,
            corpMpin: corporateProviderMpin,
            uhcProviderId: selectedProvider.uhcProviderId,
            tin: taxIdNumber,
          }),
        });
      } else {
        form.reset('utility.servicingProvider');
      }
    }
  }, [uuid, taxIdNumber, allowProviderSearch]);

  return (
    <React.Fragment>
      <CustomLabel
        id="care-provider-header"
        data-testid="care-provider-header"
        htmlFor="provider-select-providers"
      >
        Care Provider
      </CustomLabel>
      <SelectList
        id="provider-select-providers"
        data-testid="provider-select-providers"
        data-cy="provider-select-providers"
        model="utility.servicingProvider"
        aria-label="change care provider"
        aria-labelledby="care-provider-header"
        aria-required="true"
        options={providers}
        placeholder="Select Care Provider..."
        valueKey="mpin"
        isDisabled={providerResult.isLoading || !taxIdNumber}
        isLoading={providerResult.isLoading}
        validators={{ required: value => !value }}
      />
    </React.Fragment>
  );
};

CareProviders.propTypes = {
  uuid: PropTypes.string.isRequired,
  selectedProvider: PropTypes.shape({
    organizationId: PropTypes.string,
    corporateProviderMpin: PropTypes.string,
    taxIdNumber: PropTypes.string,
    uhcOrgId: PropTypes.string,
    uhcProviderId: PropTypes.string,
  }),
  setSelectedProvider: PropTypes.func.isRequired,
  allowProviderSearch: PropTypes.bool,
};

CareProviders.defaultProps = {
  selectedProvider: null,
  allowProviderSearch: true,
};
